
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateStocklocationDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    hideInV4: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    standard: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    qrcodeId: new FormControl<number | undefined>(undefined),
    parentId: new FormControl<number | undefined>(undefined),
    businessunitId: new FormControl<number | undefined>(undefined),
})
;
}
      